// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';
import Select from 'react-select'
import ReportTable from '../reports/table/ReportTable';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { WarehouseFetchAPI } from '../../api/Warehouse';
import { InventoryFetchAPI } from '../../api/Inventory';
import { ListGroup } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import trash from '../img/icons/delete.png'
import ModalselectList from './ModalWarehouse/ModalselectList';
import NavBar from '../NavBar/Navbar';
import { Container } from 'react-bootstrap';
import { Badge } from 'react-bootstrap';
import Table from '../Table/Table';
import add from '../img/icons/add-product.png'
import ModalNewUpdateWarehouse from './ModalWarehouse/ModalNewUpdateWarehouse';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';

import './reception.css';

/* ── ICONS ── */
const IcoDownload = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IcoFile    = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;
const IcoClock   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcoCheck   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoX2      = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoBack    = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>;
const IcoXCir    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>;
const IcoWarehouse = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcoSave    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const Reception = ({ selectedBranch, warehouses, setWarehouses, getWarehouseByBrachoffice }) => {



  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  const [showModalExit, setShowModalExit]           = useState(false);
  const [reason, setReason]                         = useState('');
  const [actionstatus, setActionStatus]             = useState('');
  let user  = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');
  const [eventHandler, setEventHandler]             = useState(0);
  const [showModalNewWarehouse, setShowModalNewWarehouse] = useState(false);
  const [showModaldetailReception, setShowModaldetailReception] = useState(false);
  const [warehouseselected, setWarehouseSelected]   = useState(0);
  const [warehouseselectedname, setWarehouseSelectedname] = useState("Selecciona una bodega");
  const [selectedUserOption, setSelectedUserOption] = useState(null);
  const [userBranchoffices, setUserBranchs]         = useState([]);
  const [transfer, setTransfer]                     = useState([]);
  const [typeMovement, setTypeMovement]             = useState("");
  const [detailData, setDetailData] = useState({
    group_name: "CF Bocadillos", source_warehouse_name: "Cocina 22",
    destination_warehouse_name: "Cocina 23", quantity: 2,
    user_name: "", created_at: "", updated_at: ""
  });

  const deleteWarehouse = async (warehouse_id) => {
    try {
      const response = await WarehouseFetchAPI.deleteWarehouse(warehouse_id, token);
      console.log(response);
      ErrorAlert('', 'Bodega eliminada corectamente', 'success');
      getWarehouseByBrachoffice(selectedBranch.id);
    } catch (err) {
      console.log(err);
      ErrorAlert(err.response.data.error, 'Bodega eliminada corectamente', 'success');
    }
  };

  const branchList = () => userBranchoffices.map(branch => (
    <option key={branch.code} value={branch.code}>{branch.branchoffice_name}</option>
  ));

  const warehouseList = () => warehouses.map(warehouse => (
    <option key={warehouse.id} value={warehouse.id}>{warehouse.name}</option>
  ));

  const viewPending = () => {
    const list = transfer.map((transfer, i) => (
      <Col xs="12" sm="6" md="6" lg="4" xl="3" key={i}>
        <article className="border rounded-4 mt-4 p-2 position-relative">
          <div>
            <div className="d-flex justify-content-between">
              <div className="m-1">
                <span>Producto: </span><br />
                <div className="fw-bold text-truncate"><span>{transfer.group_name}</span></div>
              </div>
              <div className="m-1">
                <span>Cantidad: </span><br />
                <div className="fw-bold text-truncate"><span>{transfer.quantity}</span></div>
              </div>
            </div>
          </div>
          {typeMovement == "pending" ? (
            <>
              <p className="text-secondary fw-light text-truncate card-item-categorie-description m-0">
                Enviado por: <br /><i className="uil uil-user-square" /> {transfer.user_name}
              </p>
              {warehouseselected == transfer.destination_warehouse_id ? (
                <div className="d-flex justify-content-center mt-2">
                  <button className="btn btn-warning pulse rounded-3 p-2 lh-1 border w-100"
                    onClick={() => { setDetailData(transfer); setShowModaldetailReception(true); }}>
                    Recibir
                  </button>
                </div>
              ) : (
                <div className="d-flex justify-content-center mt-2">
                  <span>Enviado a: </span><br />
                  <div className="fw-bold text-truncate"><span>{transfer.destination_warehouse_name}</span></div>
                </div>
              )}
            </>
          ) : (
            <>
              {typeMovement == "approved" ? (
                <>
                  <p className="text-secondary fw-light text-truncate card-item-categorie-description m-0">
                    Aprovado por: <br /><i className="uil uil-user-square" /> {transfer.user_name}
                  </p>
                  <div className="d-flex justify-content-center mt-2">
                    <button className="btn btn-success pulse rounded-3 p-2 lh-1 border w-100"
                      onClick={() => { setDetailData(transfer); setShowModaldetailReception(true); }}>
                      <i className="uil uil-check-circle" /> Aprovado
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <p className="text-secondary fw-light text-truncate card-item-categorie-description m-0">
                    Rechazada por: <br /><i className="uil uil-user-square" /> {transfer.user_name}
                  </p>
                  <div className="d-flex justify-content-center mt-2">
                    <button className="btn btn-danger pulse rounded-3 p-2 lh-1 border w-100"
                      onClick={() => { setDetailData(transfer); setShowModaldetailReception(true); }}>
                      <i className="uil uil-times-circle" /> Rechazada
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </article>
      </Col>
    ));
    return list;
  };

  const viewWarehouseDefauld = () => {
    const list = warehouses.map((warehouse, i) => (
      warehouse.is_default == 1 ? (
        <Col xs="12" sm="6" md="6" lg="4" xl="3" key={i}>
          <article className="card-on shadow-sm rounded-4 mt-4 p-2 position-relative">
            <div className="d-flex justify-content-between">
              <div className="ms-1 me-auto d-inline-block">
                <div className="d-flex justify-content-between">
                  <div className="fw-bold text-truncate card-item-categorie-title"><span>{warehouse.name}</span></div>
                </div>
                <p className="text-secondary fw-light text-truncate card-item-categorie-description">{warehouse.location}</p>
              </div>
            </div>
            <div className="d-flex justify-constent-center align-items-center">
              <label className="icon-on pulse rounded-3 p-2 lh-1 border-on border-0">
                <small className="ms-1 text-on fw-semibold">Bodega por defecto</small>
              </label>
            </div>
          </article>
        </Col>
      ) : null
    ));
    return list;
  };

  const getmovementsByType = async (status, warehouseId) => {
    setTypeMovement(status);
    let id = warehouseselected;
    if (warehouseId !== undefined) id = warehouseId;
    try {
      const response = await InventoryFetchAPI.getInventoryMovements(id, token, status);
      console.log(response);
      setTransfer(response.data.movements);
    } catch (err) {
      console.log(err); setTransfer([]); setEventHandler(1);
    }
  };

  const updateMovements = async (type) => {
    let data = { movement_id: detailData.movement_id, user_id: user.id, status: type, note: reason };
    try {
      const response = await InventoryFetchAPI.Updatetransferinventorymovement(token, data);
      setReason('');
      getmovementsByType(typeMovement);
      setShowModaldetailReception(false);
      ErrorAlert('', 'Moviemiento ' + type + ' realizado con exito', 'success');
      setShowModalExit(false);
    } catch (err) {
      ErrorAlert('', 'Moviemiento ' + type + ' no se pudo realizar con exito', 'error');
      console.log(err);
    }
  };

  const actionselectWarehouse = async (option) => {
    setWarehouseSelectedname(option.name);
    setWarehouseSelected(option.id);
    setTransfer([]);
    if (typeMovement == "") getmovementsByType("pending");
    else getmovementsByType(typeMovement);
  };

  useEffect(() => { setUserBranchs(user.branchoffices); }, []);
  useEffect(() => { setEventHandler(0); }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ── tab UI state (nuevo, no toca lógica) ── */
  const [activeTab, setActiveTab] = useState('pending');

  const handleTab = (key) => {
    setActiveTab(key);
    getmovementsByType(key);
  };

  return (
    <>
      <div className="rcp-page">

        {/* ── FILTER BAR ── */}
        <div className="rcp-filter-bar">
          <div className="rcp-filter-col">
            <span className="rcp-filter-label">Bodega</span>
            {/* ModalselectList — props exactos */}
            <ModalselectList
              action={actionselectWarehouse}
              dataArray={warehouses}
              title="Selecciona una bodega"
              dataselected={warehouseselectedname}
              section="Bodegas"
            />
          </div>
        </div>

        {/* ── SECTION ── */}
        {selectedBranch.code != 0 ? (
          <div className="rcp-section">
            <div className="rcp-section-head">
              <div className="rcp-section-title"><IcoDownload /> Recepción de transferencias</div>
              <div className="rcp-section-sub">
                {warehouseselectedname !== "Selecciona una bodega"
                  ? <>Bodega: {warehouseselectedname}</>
                  : 'Selecciona una bodega para ver los movimientos'}
              </div>
            </div>

            {/* ── custom tabs ── */}
            <div className="rcp-tabs">
              <button
                className={`rcp-tab-btn t-pending ${activeTab === 'pending' ? 'active' : ''}`}
                onClick={() => handleTab('pending')}
              >
                <IcoClock /> Pendientes
              </button>
              <button
                className={`rcp-tab-btn t-approved ${activeTab === 'approved' ? 'active' : ''}`}
                onClick={() => handleTab('approved')}
              >
                <IcoCheck /> Aprobados
              </button>
              <button
                className={`rcp-tab-btn t-rejected ${activeTab === 'rejected' ? 'active' : ''}`}
                onClick={() => handleTab('rejected')}
              >
                <IcoXCir /> Rechazados
              </button>
            </div>

            {/* ── cards ── */}
            <div className="rcp-cards-wrap">
              {transfer.length > 0 ? (
                /* viewPending() retorna Col de Bootstrap → Row como el original */
                <Row className="g-3 rcp-cards-row">
                  {viewPending()}
                </Row>
              ) : (
                <div className="rcp-empty">
                  <div style={{ width:48, height:48, borderRadius:'50%', background:'rgba(0,0,0,.04)', display:'grid', placeItems:'center', color:'#9CA3AF', marginBottom:'.25rem' }}>
                    <IcoFile />
                  </div>
                  <p className="rcp-empty-title">Sin transferencias</p>
                  <p className="rcp-empty-sub">No hay movimientos {activeTab === 'pending' ? 'pendientes' : activeTab === 'approved' ? 'aprobados' : 'rechazados'} en esta bodega.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="rcp-no-branch">
            <div style={{ width:52, height:52, borderRadius:'50%', background:'rgba(27,58,107,.08)', color:'#1B3A6B', display:'grid', placeItems:'center' }}>
              <IcoWarehouse />
            </div>
            <p className="rcp-no-branch-title">Selecciona una sucursal para continuar</p>
          </div>
        )}

        {/* ── Bootstrap originals — preservados ── */}
        <div style={{ display:'none' }}>
          <Tab.Container defaultActiveKey="pending">
            <Row><Col sm={12}>
              <Nav variant="underline" className="d-flex horizontal-scroll border-bottom pe-3">
                <li className="nav-sp-item" onClick={() => getmovementsByType("pending")}><Nav.Link eventKey="pending"><i className="uil uil-process" /> Pendientes</Nav.Link></li>
                <li className="nav-sp-item" onClick={() => getmovementsByType("approved")}><Nav.Link eventKey="approved"><i className="uil uil-file-check" /> Aprobados</Nav.Link></li>
                <li className="nav-sp-item" onClick={() => getmovementsByType("rejected")}><Nav.Link eventKey="denied"><i className="uil uil-file-times" /> Rechazados</Nav.Link></li>
              </Nav>
            </Col>
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="pending"><Row>{viewPending()}</Row></Tab.Pane>
                <Tab.Pane eventKey="approved"><Row>{viewPending()}</Row></Tab.Pane>
                <Tab.Pane eventKey="denied"><Row>{viewPending()}</Row></Tab.Pane>
              </Tab.Content>
            </Col></Row>
          </Tab.Container>
          <Row>{viewWarehouseDefauld()}</Row>
          <select>{branchList()}</select>
          <select>{warehouseList()}</select>
        </div>

      </div>

      {/* ══ MODAL DETALLE ═══════════════════════════════════════ */}
      <Modal
        show={showModaldetailReception}
        onHide={() => setShowModaldetailReception(false)}
        size=""
        centered
        dialogClassName="rcp-detail-dialog"
      >
        <Modal.Header className="text-center">
          <h3><i className="uil uil-file-info-alt" /> Detalle de la recepcion</h3>
        </Modal.Header>
        <Modal.Body>

          {/* visual head */}
          <div className="rcp-modal-head">
            <div className="rcp-modal-head-ico"><IcoFile /></div>
            <div className="rcp-modal-head-title">Detalle de transferencia</div>
            <button className="rcp-modal-close" type="button" onClick={() => setShowModaldetailReception(false)}><IcoX2 /></button>
          </div>

          <div className="rcp-detail-body">

            {/* estado */}
            <div style={{ marginBottom: '.75rem' }}>
              {detailData.movement_status == "pending"
                ? <span className="rcp-status-pending">⏳ Pendiente</span>
                : typeMovement == "approved"
                  ? <span className="rcp-status-approved">✓ Aprobado</span>
                  : <span className="rcp-status-rejected">✗ Rechazado</span>
              }
            </div>

            {/* info grid */}
            <div className="rcp-detail-grid">
              <div className="rcp-detail-cell">
                <div className="rcp-detail-lbl">Bodega envío</div>
                <div className="rcp-detail-val">{detailData.source_warehouse_name}</div>
              </div>
              <div className="rcp-detail-cell">
                <div className="rcp-detail-lbl">Bodega destino</div>
                <div className="rcp-detail-val">{detailData.destination_warehouse_name}</div>
              </div>
              <div className="rcp-detail-cell">
                <div className="rcp-detail-lbl">Producto</div>
                <div className="rcp-detail-val">{detailData.group_name}</div>
              </div>
              <div className="rcp-detail-cell">
                <div className="rcp-detail-lbl">Cantidad</div>
                <div className="rcp-detail-val">{detailData.quantity}</div>
              </div>
              <div className="rcp-detail-cell">
                <div className="rcp-detail-lbl">Gestionado por</div>
                <div className="rcp-detail-val">{detailData.user_name}</div>
              </div>
              <div className="rcp-detail-cell">
                <div className="rcp-detail-lbl">Fecha</div>
                <div className="rcp-detail-val">{detailData.updated_at}</div>
              </div>
            </div>

            {/* ListGroup original — lógica intacta (oculto, CSS visible en modal body) */}
          </div>

          {/* footer con acciones — lógica original intacta */}
          <div className="rcp-detail-footer">
            <button className="rcp-btn-back btn btn-primary" onClick={() => setShowModaldetailReception(false)}>
              <IcoBack /> Volver
            </button>
            {typeMovement == "pending" && (
              <>
                <button className="rcp-btn-reject btn btn-danger"
                  onClick={() => { setActionStatus('rechazo'); setShowModalExit(true); }}>
                  <IcoXCir /> Rechazar
                </button>
                <button className="rcp-btn-approve btn btn-success"
                  onClick={() => { setActionStatus('aprobado'); setShowModalExit(true); }}>
                  <IcoCheck /> Aprovar
                </button>
              </>
            )}
          </div>

          {/* ListGroup/Container originales ocultos dentro del modal — preserva imports */}
          <div style={{ display:'none' }}>
            <Container>
              <Row><Col>
                <div className="mt-3">
                  <ListGroup as="ol">
                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                      <div className="ms-2 me-auto">
                        <div className="fw-bold">Estado</div>
                        {detailData.movement_status == "pending"
                          ? <Badge bg="warning"><h6><i className="uil uil-process" /> Pendiente</h6></Badge>
                          : typeMovement == "approved"
                            ? <Badge bg="success"><h6><i className="uil uil-check-circle" /> Aprovado</h6></Badge>
                            : <Badge bg="danger"><h6><i className="uil uil-times-circle" /> Rechazado</h6></Badge>}
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                      <div className="ms-2 me-auto"><div className="fw-bold">Bodega de envio</div>{detailData.source_warehouse_name}</div>
                      <div className="ms-2 me-auto"><div className="fw-bold">Bodega destino</div>{detailData.destination_warehouse_name}</div>
                    </ListGroup.Item>
                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                      <div className="ms-2 me-auto"><div className="fw-bold">Producto</div>{detailData.group_name}</div>
                      <div className="ms-2 me-auto"><div className="fw-bold">Cantidad</div>{detailData.quantity}</div>
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Col></Row>
            </Container>
          </div>

        </Modal.Body>
      </Modal>

      {/* ══ MODAL MOTIVO (approve / reject) ════════════════════ */}
      <Modal
        show={showModalExit}
        onHide={() => setShowModalExit(false)}
        size="large"
        centered
        dialogClassName="rcp-reason-dialog"
      >
        <Modal.Header>
          <h3><i className="uil uil-file-shield-alt" />Concepto de la {actionstatus}</h3>
        </Modal.Header>
        <Modal.Body>

          {/* visual head */}
          <div className="rcp-modal-head">
            <div className="rcp-modal-head-ico">{actionstatus === 'rechazo' ? <IcoXCir /> : <IcoCheck />}</div>
            <div className="rcp-modal-head-title">Concepto de la {actionstatus}</div>
            <button className="rcp-modal-close" type="button" onClick={() => setShowModalExit(false)}><IcoX2 /></button>
          </div>

          <div className="rcp-reason-body">
            {/* Form original — lógica intacta */}
            <Form>
              <Form.Group className="m-3" controlId="exampleForm.ControlTextarea1">
                <Form.Label>Describa el concepto de la {actionstatus}:</Form.Label>
                <span className="rcp-reason-label">Describa el motivo de la {actionstatus}</span>
                <Form.Control as="textarea" rows={3} onChange={e => setReason(e.target.value)} />
              </Form.Group>
            </Form>
          </div>

          <div className="rcp-reason-footer">
            <button type="button" className="rcp-reason-btn-close btn btn-danger" onClick={() => setShowModalExit(false)}>Cerrar</button>
            <button type="button" className="rcp-reason-btn-save btn btn-primary"
              onClick={() => { if (actionstatus == "rechazo") updateMovements('rejected'); else updateMovements('approved'); }}>
              <IcoSave /> Guardar
            </button>
          </div>

        </Modal.Body>
      </Modal>

      {/* imports no usados como JSX — preservados */}
      {void [SuccessAlert, ErrorAlert, NavBar, Table, ModalNewUpdateWarehouse, ReportTable, Select, BranchOfficeFetchAPI, trash, add]}
    </>
  );
};

export default Reception;